import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconSearchLight as IconSearch } from '@alfa-bank/site-icon/search-light';

import { IconCross } from '../components/icon-cross/cross';
import { IconButton } from '../components/icon-button';
import { IconInput } from '../components/icon-input';
import { Label } from '../components/label';

import styles from './styles.css';
import { SearchInput as Component } from './search-input';
import type { ISearchInputDeps, TSearchInput } from './models';

export const SearchInput = createWidget<ISearchInputDeps, TSearchInput>({
    Label,
    Input: IconInput,
    IconButton,
    IconSearch,
    IconCross,
    styles,
})(Component);
